<script>
    import { Route, Link, Router } from 'yrv'
    import Content from '../../_common/content.svelte'
    import DocsEntries from './docs-entries.svelte'
</script>

<Content>
    <div class="root-content">
        <div class="tab">
            <Link class="link" href="/documents/list">Documentos</Link>
            <div class="spacer" />
        </div>
        <div class="body">
            <Router>
                <Route path="/list">
                    <DocsEntries />
                </Route>
            </Router>
        </div>
    </div>
</Content>

<style>
    .tab {
        border-bottom-color: rgb(var(--menu-color));
    }
    .tab :global([aria-current='page']) {
        background-color: rgba(var(--menu-color), 0.9);
    }
</style>
